import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_CUSTOMER_STATUS, {
      pathParams: {
        customerId: id,
      },
    })
  },

  method: 'PATCH',

  format(payload) {
    const { status } = payload || {}
    return {
      status
    }
  },

  parse(raw = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to update customer status',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Statut du client mis à jour',
      data: raw.data,
    }
  },
}
